module.exports = __webpack_public_path__ + "static/IMG_1868-82a2e5256aaf6b7f524755e83ef86be0.jpeg";